import lodash from 'lodash'
import { GroupList, EmployeeList } from '@/pages/case/dialog/data.d'
import * as services from '@/pages/case/dialog/service'
import { formatCaseList } from './util'

export interface ModelState {
  groupList: GroupList
  groupId: string
  caseList: EmployeeList
  caseTotal: number
}

export const DEFAULT_ID = '000000000000000000000000'

const UserModel = {
  namespace: 'departmentList',

  state: {
    groupList: [],
    groupId: DEFAULT_ID,
    caseList: [],
    caseTotal: 0,
    dialogDetail: {},
  },

  subscriptions: {
    setup: ({ dispatch, history }) => {
      return history.listen(({ pathname }) => {
        if (pathname === '/bank/case/dialog') {
          dispatch({
            type: 'fetchDepartmentList',
            payload: {},
          })
        }
      })
    },
  },
  effects: {
    *fetchDepartmentList({ payload }, { call, put, select }) {
      const response = yield call(services.fetchDepartmentList)
      yield put({
        type: 'setState',
        payload: { groupList: response.data.groups || [] },
      })
    },

    *dialogDetail({ payload }, { call, put }) {
      const result = yield call(services.dialogDetail, payload)
      yield put({
        type: 'setState',
        payload: {
          dialogDetail: result?.data,
        },
      })
      return result
    },

    *createDepartment({ payload }, { call, put }) {
      const result = yield call(services.createDepartment, payload)
      yield put({ type: 'fetchDepartmentList' })
      return result
    },

    *deleteDepartment({ payload }, { call, put }) {
      const result = yield call(services.deleteDepartment, payload)
      yield put({
        type: 'setState',
        payload: {
          groupId: DEFAULT_ID,
        },
      })
      yield put({ type: 'fetchDepartmentList' })
      return result
    },

    *deleteGroups({ payload }, { call, put }) {
      const result = yield call(services.deleteGroups, payload)
      yield put({ type: 'fetchDepartmentList' })
      return result
    },

    *updateDepartment({ payload }, { call, put }) {
      const result = yield call(services.updateDepartment, payload)
      yield put({ type: 'fetchDepartmentList' })
      return result
    },

    *dropDepartment({ payload }, { call, put }) {
      const result = yield call(services.dropDepartment, payload)
      yield put({ type: 'fetchDepartmentList' })
      return result
    },

    *fetchCaseList({ payload }, { call, put, select }) {
      const result = yield call(services.fetchCaseList, payload)
      yield put({
        type: 'setState',
        payload: {
          groupId: payload?.dialog_case_group_id || '000000000000000000000000',
          caseList: formatCaseList(result.data.dialog_cases) || [],
          caseTotal: result.data.page.total,
        },
      })
      return result
    },

    *updateCase({ payload }, { call, put }) {
      const result = yield call(services.updateCase, payload)
      return result
    },

    *deleteCase({ payload }, { call, put }) {
      const result = yield call(services.deleteCase, payload)
      return result
    },

    *moveCase({ payload }, { call, put }) {
      const result = yield call(services.moveCase, payload)
      return result
    },

    *importFile({ payload }, { put, call, take }) {
      const formData = new FormData()
      formData.append('import_mode', payload.importMode)
      formData.append('file', payload.file)
      const res = yield call(services.importFile, formData)
      yield put({ type: 'fetchCaseList' })
      return res
    },

    *reset(_, { put }) {
      yield put({
        type: 'departmentList/setState',
        payload: { groupId: DEFAULT_ID },
      })
      yield put({
        type: 'departmentList/fetchCaseList',
        payload: {
          dialog_case_group_id: DEFAULT_ID,
          page: {
            page_num: 1,
            page_size: 20,
          },
        },
      })
    },
  },
  reducers: {
    setState(state = {}, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },
}

export default UserModel
